import { Placeholder as PlaceholderExtension } from '@tiptap/extension-placeholder';
import { Plugin } from '@tiptap/pm/state';
import { DecorationSet } from '@tiptap/pm/view';
import { assertPluginKey } from './utils/plugin';

export const Placeholder = PlaceholderExtension.extend({
  addProseMirrorPlugins() {
    const plugins = this.parent?.() ?? [];
    const placeholderPlugin = plugins[0];

    if (!placeholderPlugin) {
      throw new Error('Failed to replace placeholder plugin');
    }

    assertPluginKey(placeholderPlugin, PlaceholderExtension.name);

    const originalDecorationsProp = placeholderPlugin.props.decorations;
    const decorationsPropWrapper: Plugin<unknown>['props']['decorations'] = (state) => {
      const decorationSource = originalDecorationsProp?.bind(placeholderPlugin)?.(state);

      let firstDecorationSet: DecorationSet | undefined;

      decorationSource?.forEachSet((set) => {
        if (!firstDecorationSet) {
          firstDecorationSet = set;
        }
      });

      // We check the firstDecorationSet and see if it's length is bigger than 0. If so we can safely return the original value.
      if (firstDecorationSet && firstDecorationSet?.find(1)?.length > 0) {
        return decorationSource;
      }

      return null;
    };

    placeholderPlugin.props.decorations = decorationsPropWrapper;

    return plugins;
  },
}).configure({
  placeholder: 'Type something...',
  showOnlyWhenEditable: false,
});
